import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import Assessments from "./Assessments";

import { exportXlsx, submissionsApi } from "../../../../../../utils";
import { throwApiError } from "../../../../../lms-shared/store/error-handling-actions";
import { Filter, FilterExtention, FilterItem, FilterTypesEnum, Filters } from "../../../../../UI/Filter";
import StoryLineReport from "../SubmmisionsList/sources/StoryLine"
import SLCReport from "../SubmmisionsList/sources/SLC"

import classes from "./AssessmentsFilterList.module.css";

const AssessmentsFilterList = ({ assessments, currentAssessmentId, setCurrentAssessmentId }) => {

    const dispatch = useDispatch()
    const { id, guid } = useParams();
    const { texts, direction } = useSelector(state => state.translate);

    const report = {
        SLCQuestionnaire: SLCReport,
        StorylineQuestionnaire: StoryLineReport
    }

    const exportFiles = () => {
        if (guid !== "0") {
            const data =
            {
                studyGroupId: id,
                toCId: guid
            }
            submissionsApi.submissionsReportPost({ submissionStatisticInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.submissionsAllStudentsStatisticError, error: error, statusCode: response?.statusCode, message: "submissionsAllStudentsStatisticError " + error.message, level: 2, component: "StudentsLayout", line: 54 }))
                }
                else {
                    if (resdata.length) {
                        let arr = [], filename, headerNames, currentAssessment;
                        for (let i = 0; i < resdata.length; i++) {
                            filename = resdata[i].name;
                            headerNames = [];
                            headerNames.push([texts.slideName, ...resdata[i].users[0].assessment?.map(a => assessments.find(ass => ass.id === a.assessmentId)?.parentName)]);
                            headerNames.push([texts.studentName, ...resdata[i].users[0].assessment?.map(a => a.assessmentName)]);
                            arr = []
                            resdata[i].users.forEach(u => {
                                let obj = { [texts.name]: u.firstName + ' ' + u.lastName }
                                arr.push(obj)
                                u.assessment.forEach((assessment, index) => {
                                    currentAssessment = assessments.find(a => a.id == assessment.assessmentId)
                                    obj[index] = report[currentAssessment?.sourceType]?.[currentAssessment?.assessmentTypeId]?.converSultion({ ...assessment.submission, assessmentContentData: currentAssessment.contentData })
                                })
                            })
                            exportXlsx(filename, headerNames, arr, true);
                        }
                    }
                }
            })
        }
    }

    return (
        <div className={`${classes[direction]} ${classes.AssessmentsList}`} >
            <div className={`${classes[direction]} ${classes.AssessmentsListDirection}`} >
                <div className={classes.DownloadExelIcon} onClick={exportFiles}></div>
                <FilterExtention list={assessments} filterWidth={"80%"}  >
                    <Filters >
                        <Filter name="free" text={texts.freeFilter} type={FilterTypesEnum.free}></Filter>
                    </Filters>
                    <FilterItem>
                        <Assessments assessments={assessments} currentAssessmentId={currentAssessmentId} setCurrentAssessmentId={setCurrentAssessmentId}></Assessments>
                    </FilterItem>
                </FilterExtention>
            </div>
        </div>
    )
}
export default AssessmentsFilterList